export default function Container(props) {
    
    return (<div className="w100 row hcenter mtop15">
        <div className="mxw1000px row wrap">
                {props.children}
        </div>
    </div>)
}